import { jsx as r } from "react/jsx-runtime";
import { Link as k } from "@chakra-ui/react";
const d = ({ as: i, children: t, href: o, size: m = "md", ...n }) => /* @__PURE__ */ r(k, { as: i, href: o, to: i && o ? o : void 0, size: m, ...n, children: t });
export {
  d as Link
};
